import SimpleTable from '#app/components/SimpleTable.tsx'
import { listRaces } from '#app/queries/Results-queries.ts'
import { useDebounce } from '#app/utils/misc.tsx'
import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/20/solid'
import { Label } from '@radix-ui/react-label'
import { Button, Card, TextFieldInput } from '@radix-ui/themes'
import { useLoaderData, useSearchParams, useSubmit } from '@remix-run/react'
import { type LoaderFunctionArgs, json } from '@remix-run/server-runtime'
import { type ChangeEvent } from 'react'

export async function loader({ request }: LoaderFunctionArgs) {
	const searchParams = new URL(request.url).searchParams
	const search = searchParams.get('search') || ''
	const page = parseInt(searchParams.get('page') || '') || 0
	const { races, pageCount } = await listRaces(search, page)
	return json({ races, page, search, pageCount })
}

export default function Races() {
	const loaderData = useLoaderData<typeof loader>()
	const submit = useSubmit()

	function onChange(e: ChangeEvent<HTMLInputElement>) {
		const value = e.target.value.trim()
		if (value) submit({ search: value })
		else submit({})
	}

	function onPageChange(type: 'forward' | 'back') {
		if (type === 'back' && loaderData.page === 0) return
		if (type === 'back') {
			const params: any = { page: loaderData.page - 1 }
			if (loaderData.search) params['search'] = loaderData.search
			submit(params)
		}
		if (type === 'forward' && loaderData.page === loaderData.pageCount - 1) return
		if (type === 'forward') {
			const params: any = { page: loaderData.page + 1 }
			if (loaderData.search) params['search'] = loaderData.search
			submit(params)
		}
	}

	const mapping = {
		Race: 'raceName',
	}

	return (
		<div className="flex justify-center">
			<div className="flex max-h-full max-w-[700px] flex-1 flex-col items-center gap-y-4">
				<Card className="w-full">
					<div className="flex flex-col gap-y-2">
						<div>
							Results from the following races have been incorporated into MarathonRank.com. You may
							search to see if a race is included below.
						</div>
						<div>
							<Label className="font-bold">Search Races</Label>
							<TextFieldInput
								onChange={useDebounce(onChange, 250)}
								className="flex w-full flex-1"
							/>
						</div>
					</div>
				</Card>
				<div className="w-full overflow-y-scroll">
					<SimpleTable mapping={mapping} data={loaderData.races} />
					{loaderData.races.length > 0 && (
						<div className="mt-2 flex justify-end gap-x-2">
							<Button variant="outline" onClick={() => onPageChange('back')}>
								<ArrowLeftIcon height="2rem" />
							</Button>
							<Button variant="outline" onClick={() => onPageChange('forward')}>
								<ArrowRightIcon height="2rem" />
							</Button>
						</div>
					)}
				</div>
				{loaderData.races.length === 0 && <div>No Results Found</div>}
			</div>
		</div>
	)
}
